// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import ClaimPart from '@deere/cps-it.warranty-model-factory/lib/claim-item-part';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../claim-fields/key-value-dropdown';
import Part from '@deere/cps-it.warranty-model-factory/lib/part';
import {translate} from '../../../../shared/services/translation-service';

function handleQuantityChange(quantity) {

    this.onQuantityChange(quantity);

}

function handlePartNumberChange(event) {

    this.onPartNumberChange(event.target.value);

}

function handleSerialNumberChange(event) {

    this.onSerialNumberChange(event.target.value);

}

function handleInvoiceNumberChange(event) {

    this.onInvoiceNumberChange(event.target.value);

}

function handleUnitChange(event) {

    this.onUnitChange(event.target.value, this.partDetails.unit);

}

function handleBlur(event) {

    this.onPartNumberBlur(event.target.value);

}

class PartsPanelRowBody extends Component {

    componentWillMount() {

        if (this.props.part.partNumber) {

            this.props.onPartNumberBlur(this.props.part.partNumber);

        }

    }

    render() {

        const showInvoiceNumber = this.props.showPartInvoiceNumber;

        return (
            <div className={showInvoiceNumber ? 'separator' : ''}>
                <section className={`parts-panel-row-body part-item-${this.props.part.lineNumber} ${this.props.highlightClass}`}>
                    <FormattedNumberInput
                        allowNegative={false}
                        className='quantity'
                        decimalPrecision={2}
                        isValidInput={value => value < 100000}
                        onValueChange={this.props::handleQuantityChange}
                        value={this.props.part.quantity}
                    />
                    <input
                        className='part-number'
                        maxLength={40}
                        onBlur={this.props::handleBlur}
                        onChange={this.props::handlePartNumberChange}
                        type='text'
                        value={this.props.part.partNumber}
                    />
                    <span className='description'>{this.props.part.partDescription}</span>
                    <KeyValueDropDown
                        className='unit'
                        list={this.props.partDetails ? this.props.partDetails.unit : []}
                        onChange={this.props::handleUnitChange}
                        value={this.props.part.unit.key}
                    />
                    <div className='serial-number'>
                        <input
                            maxLength={18}
                            onChange={this.props::handleSerialNumberChange}
                            placeholder={showInvoiceNumber ? translate('SERIAL_NUMBER') : ''}
                            type='text'
                            value={this.props.part.partSerialNumber}
                        />
                        {showInvoiceNumber &&
                            <input
                                className='invoice-number'
                                maxLength={15}
                                onChange={this.props::handleInvoiceNumberChange}
                                placeholder={translate('INVOICE_NUMBER')}
                                type='text'
                                value={this.props.part.invoiceNumber}
                            />
                        }
                    </div>
                    <span className='delete-icon-button'>
                        <button
                            className='icon-trash-can'
                            onClick={this.props.onDelete}
                        />
                    </span>
                </section>
                {this.props.vsrMessage &&
                    <span className='vsr-message'>{`${this.props.vsrMessage}(${translate('SAVE_TO_VALIDATE')})`}</span>
                }
            </div>
        );

    }
}

PartsPanelRowBody.displayName = 'PartsPanelRowBody';
PartsPanelRowBody.propTypes = {
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    numberOfParts: PropTypes.number.isRequired,
    onDelete: PropTypes.func.isRequired,
    onInvoiceNumberChange: PropTypes.func.isRequired,
    onPartNumberBlur: PropTypes.func.isRequired,
    onPartNumberChange: PropTypes.func.isRequired,
    onQuantityChange: PropTypes.func.isRequired,
    onSerialNumberChange: PropTypes.func.isRequired,
    onUnitChange: PropTypes.func.isRequired,
    part: PropTypes.instanceOf(ClaimPart).isRequired,
    partDetails: PropTypes.instanceOf(Part),
    showPartInvoiceNumber: PropTypes.bool.isRequired,
    vsrMessage: PropTypes.string
};

export default PartsPanelRowBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/parts-panel/parts-panel-row-body.js